var _path, _circle;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTagCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.41 22.58L23.41 13.58C23.05 13.22 22.55 13 22 13H15C13.9 13 13 13.9 13 15V22C13 22.55 13.22 23.05 13.59 23.42L22.59 32.42C22.95 32.78 23.45 33 24 33C24.55 33 25.05 32.78 25.41 32.41L32.41 25.41C32.78 25.05 33 24.55 33 24C33 23.45 32.77 22.94 32.41 22.58ZM16.5 18C15.67 18 15 17.33 15 16.5C15 15.67 15.67 15 16.5 15C17.33 15 18 15.67 18 16.5C18 17.33 17.33 18 16.5 18Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagCircle);
export default __webpack_public_path__ + "static/media/tagCircle.123500e6753b30d0e3105fc9c16a9f69.svg";
export { ForwardRef as ReactComponent };